export default __webpack_public_path__ + "static/media/klee-miearphone.155cf1ae.jfif";